import { pessoaModel } from '@/models/pessoa'

export const colaboradorModel = {
  colaborador: function () {
    return {
      id: '',
      pessoa_id: '',
      pessoa: new pessoaModel.pessoa(),
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/Colaborador/_model/colaborador.js